export enum TreatmentType {
  Liquid = 'liquid',
  Powder = 'powder',
  Solid = 'solid',
}
